<script lang='ts'>
import { useNavigate } from "svelte-navigator";
import { loginUser } from '../store';
import { login, HttpError } from '../services';
import * as config from '../config.json';

export let title;
export let subtitle;

interface LoginResponse {
  id: string;
  token: string;
}

const navigate = useNavigate();

let email = '';

let error;
let loading = false;

async function handleSubmit(e) {
  error = undefined;

  if (email.length === 0) {
    error = 'Please enter your email';
    return;
  }

  loading = true;

  try {
    const {id, token}: LoginResponse = await login({email, eventId: config.eventId, companyId: config.companyId});
    loginUser(id, token, email)
    navigate('/', { replace: true });
  } catch (e) {
    if (e instanceof HttpError && e.status === 401) {
      error = "Unregistered email";
    } else {
      console.error(e);
      error = e.message;
    }
  } finally {
    loading = false;
  }
}
</script>

<div class="login-title">
  {@html title}
</div>

<div class="login-subtitle">
  {@html subtitle}
</div>

<form on:submit|preventDefault={handleSubmit}>
  {#if error}
    <div class="error-box mb-4">{error}</div>
  {/if}

  <div class="col mb-4">
    <div class="form-label">Email</div>
    <input bind:value={email} type="email" name="email" placeholder="Email" />
  </div>
  
  <div class="row vcenter end" style="margin-top: 16px">
    <button type="submit" class="button secondary" disabled={loading}>sign in</button>
  </div>
</form>